(() => {
  const formId = 'WiKKmf';
  const signupCopy = 'Get a restock alert and VibeHaus emails. Unsubscribe anytime.';
  const submitted = new Set();

  function captureSignup(event) {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (event.type === 'click') {
      const button = target.closest('button');
      if (!button || button.textContent.trim() !== 'Notify me') return;
    }
    const form = target.closest('form[data-testid="klaviyo-form-' + formId + '"]');
    if (!form || !form.textContent.includes(signupCopy) || form.querySelector('input[type="checkbox"]')) return;
    const input = form.querySelector('input[type="email"][name="email"]');
    if (!input || !input.validity.valid) return;
    const email = input.value.trim().toLowerCase();
    if (!email || submitted.has(email)) return;
    submitted.add(email);
    subscribe(email);
  }

  async function subscribe(email, attempt = 0) {
    try {
      const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=Y3Q6zJ', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          revision: '2026-10-15'
        },
        keepalive: true,
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'VibeHaus back-in-stock signup',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email,
                    subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                  }
                }
              }
            },
            relationships: { list: { data: { type: 'list', id: 'Y5BQGN' } } }
          }
        })
      });
      if (response.ok) return;
      if ((response.status === 429 || response.status >= 500) && attempt < 2) {
        const retryAfter = Number(response.headers.get('Retry-After'));
        const delay = retryAfter > 0 ? Math.min(retryAfter, 60) * 1000 : 1000 * (2 ** attempt);
        window.setTimeout(() => subscribe(email, attempt + 1), delay);
        return;
      }
      submitted.delete(email);
      console.warn('VibeHaus restock newsletter signup could not complete.');
    } catch {
      if (attempt < 2) {
        window.setTimeout(() => subscribe(email, attempt + 1), 1000 * (2 ** attempt));
        return;
      }
      submitted.delete(email);
      console.warn('VibeHaus restock newsletter signup could not complete.');
    }
  }

  document.addEventListener('click', captureSignup, true);
  document.addEventListener('submit', captureSignup, true);
})();
